require("./adverts.scss");
require("./adverts.js");

(function (global) {
    const onGalleryOpen = () => {
        global.MMHelper.loadAdvert("6")
            .catch(function (err) {
                console.warn("MM: Error loading advert", err);
            });
    };

    const onGalleryClose = () => { };

    document.body.addEventListener("gallery:open", onGalleryOpen);
    document.body.addEventListener("gallery:close", onGalleryClose);
})(window);